import React from 'react';
import { useLocation } from 'react-router';
import NewProfessionalShift from '~/presentation/pages/NewProfessionalShift';

const MakeNewProfessionalShift: React.FC = () => {
  const { userId, from } = useLocation<{ userId: string; from: string }>()
    .state;

  return <NewProfessionalShift from={from} userId={Number(userId)} />;
};

export default MakeNewProfessionalShift;
